module.exports = __webpack_public_path__ + "static/media/Community1.23922aba.png";